import React, { useEffect, useState, useRef } from 'react';
import {
    Typography,
    Paper,
    Grid,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    IconButton,
    Button
} from '@material-ui/core';
import { connect } from "react-redux";
import { accountDetailsCss as useStyles } from './AccountDetailsCss';
import CloseIcon from '@material-ui/icons/Close';
import { TextField, Checkboxes } from 'mui-rff';
import { Form } from 'react-final-form';
import AccountDetailsIcon from '../Icons/AccountDetailsIcon';
import { accountDetails, getUserDetails } from '../../../store/actions/authActionCreators';
import * as logger from '../../../logger';
import { trackDwebEvent } from '../../analytics';

const AccountDetailsDialog = ({ dispatchToggleTripOverlay, dispatchAddUserDetails, onClose, user, open, dispatchFetchUserDetails }) => {
    let submit;
    const [dialogOpen, setDialogOpen] = useState(open);
    const [dataFlag, setDataFlag] = useState(false);
    const [whatsappFlag, setWhatsappFlag] = useState(true);

    const initialValues = {
        whatsapp: whatsappFlag
    }

    const classes = useStyles();

    const checkboxData = [
        { label: 'Get alerts and reminders in WhatsApp' },
    ];

    useEffect(() => {
        if (dialogOpen) {
            trackDwebEvent("Dweb Profile Create Initiated", {});
        }
    }, [dialogOpen]);

    const getFormFields = (values) => [
        {
            size: 12,
            visible: true,
            field: (
                <>
                    <div>
                        <div className={classes.titleV1}>Your Name</div>
                        <TextField
                            placeholder="Eg: Arjun Reddy"
                            name="partyName"
                            variant="outlined"
                            size="small"
                            fieldProps={{
                                parse: value => value && (value.trim()).length == 0 ? value.trim() : value
                            }}
                            className={classes.textV1}
                        />
                    </div>
                </>
            )
        },
        {
            size: 12,
            visible: true,
            field: (
                <>
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>Company Name</div>
                        <TextField
                            placeholder="Eg: Sri Ram Logistics"
                            name="companyName"
                            variant="outlined"
                            size="small"
                            fieldProps={{
                                parse: value => value && (value.trim()).length == 0 ? value.trim() : value
                            }}
                            className={classes.textV1}
                        />
                    </div>
                </>
            )
        },
        {
            size: 12,
            visible: true,
            field: (
                <>
                    <div className={classes.mtV2}>
                        <Checkboxes
                            name="whatsapp"
                            data={checkboxData}
                            // classes={{ root: classes.checkV1 }}
                            onClick={(e) => {
                                setWhatsappFlag(!whatsappFlag);
                                if (!whatsappFlag) {
                                    trackDwebEvent("Dweb Profile Create WhatsApp Consent ON", {
                                        name: values.partyName,
                                        company_name: values.companyName,
                                        whatsapp_consent_status: !whatsappFlag
                                    })
                                } else {
                                    trackDwebEvent("Dweb Profile Create WhatsApp Consent OFF", {
                                        name: values.partyName,
                                        company_name: values.companyName,
                                        whatsapp_consent_status: !whatsappFlag
                                    })
                                }
                            }}
                            className={classes.pV1}
                            formControlLabelProps={{
                                class: classes.checkV1
                            }}
                        />
                    </div>
                </>
            )
        }
    ]



    const validate = values => {

        const errors = {}

        let partyNameValue = values.partyName ? /^[A-Za-z]+$/.test(values.partyName.replace(/\s+/g, '')) : "";
        let companyNameValue = values.companyName ? /^[A-Za-z]+$/.test(values.companyName.replace(/\s+/g, '')) : "";

        if (!partyNameValue) {
            errors.partyName = "Enter your name."
        }

        if (!companyNameValue) {
            errors.companyName = "Enter your company name."
        }


        if (partyNameValue && companyNameValue) {
            setDataFlag(true);
        } else {
            setDataFlag(false);
        }
        return errors;

    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const onSubmit = values => {
        let partyNameArray = values.partyName.split(" ");
        let partyNameCapitalize = [];

        if (partyNameArray && partyNameArray.length > 0) {
            partyNameArray.forEach((value) => {
                if (value) {
                    partyNameCapitalize.push((value.charAt(0).toUpperCase()) + value.slice(1));
                }
            })
        }


        let companyNameArray = values.companyName.split(" ");
        let companyNameCapitalize = [];

        if (companyNameArray && companyNameArray.length > 0) {
            companyNameArray.forEach((value) => {
                if (value) {
                    companyNameCapitalize.push((value.charAt(0).toUpperCase()) + value.slice(1));
                }
            })
        }

        const userData = {
            name: partyNameCapitalize && partyNameCapitalize.length > 0 ? (partyNameCapitalize.join(" ")).trim() : "",
            companyName: companyNameCapitalize && companyNameCapitalize.length > 0 ? (companyNameCapitalize.join(" ")).trim() : "",
            whatsappConsent: values.whatsapp ? values.whatsapp : false
        };

        dispatchAddUserDetails(userData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Account Details Component Dweb', 'Add user details successfull');
                    dispatchFetchUserDetails(
                        (data) => {
                            logger.log("Account Details component Dweb", "Fetch user details successfull");
                            if (data && data.status && data.status.code == 200) {
                                handleClose();
                                
                                trackDwebEvent("Dweb Profile Create Successfull", {
                                    name: partyNameCapitalize && partyNameCapitalize.length > 0 ? (partyNameCapitalize.join(" ")).trim() : "",
                                    company_name: companyNameCapitalize && companyNameCapitalize.length > 0 ? (companyNameCapitalize.join(" ")).trim() : "",
                                    whatsapp_consent_status: values.whatsapp ? values.whatsapp : false
                                });
                            } else {
                                trackDwebEvent("Dweb Profile Create Failed", {
                                    name: partyNameCapitalize && partyNameCapitalize.length > 0 ? (partyNameCapitalize.join(" ")).trim() : "",
                                    company_name: companyNameCapitalize && companyNameCapitalize.length > 0 ? (companyNameCapitalize.join(" ")).trim() : "",
                                    whatsapp_consent_status: values.whatsapp ? values.whatsapp : false,
                                    error_reason: data && data.status && data.status.message ? data.status.message : ""
                                });
                            }
                        },
                        (data) => {
                            logger.log("Account Details Dweb", "Fetch user details failed");
                            trackDwebEvent("Dweb Profile Create Failed", {
                                name: partyNameCapitalize && partyNameCapitalize.length > 0 ? (partyNameCapitalize.join(" ")).trim() : "",
                                company_name: companyNameCapitalize && companyNameCapitalize.length > 0 ? (companyNameCapitalize.join(" ")).trim() : "",
                                whatsapp_consent_status: values.whatsapp ? values.whatsapp : false,
                                error_reason: data && data.status && data.status.message ? data.status.message : ""
                            });
                        }
                    );

                }
            },
            () => {
                logger.log('Account Details Component Dweb', 'Add user details failed');
            });
    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xs'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-party-dialog-title" open={dialogOpen}
                classes={{ paperScrollPaper: classes.brV1, paperWidthXs: classes.paperWidthV1 }}
            >
                {/* <DialogTitle className={classes.dialogTitle}>
                    <IconButton onClose={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle> */}

                <DialogContent className={classes.dialogContent}>
                    <div className={classes.divAlign}>
                        <div>
                            <AccountDetailsIcon />
                        </div>
                        <div className={classes.divV1}>Enter your Details</div>
                    </div>
                    <Form
                        onSubmit={onSubmit}
                        keepDirtyOnReinitialize
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>
                <DialogActions className={classes.daV1}>
                    <Button className={!dataFlag ? classes.disableCta : classes.saveCta} type="submit" variant="contained"
                        // onClick={() => {
                        //     document.getElementById('myForm')
                        //         .dispatchEvent(new Event('submit', { cancelable: true }))
                        // }}
                        onClick={event => {
                            submit(event)
                        }}
                        disabled={!dataFlag}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>


        </>
    );
}

const mapStateToProps = (state) => ({ user: state.user });
const mapDispatchToProps = (dispatch) => ({
    dispatchAddUserDetails: (data, onSuccess, onFailure) => {
        dispatch(accountDetails(data, onSuccess, onFailure, true))
    },
    dispatchFetchUserDetails: (onSuccess, onFailure) => {
        dispatch(getUserDetails(onSuccess, onFailure))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountDetailsDialog);